/**
 * Credits Tab Component
 * 
 * Main container for credit management functionality.
 * Shows list view by default, switches to detail view when credit selected.
 */

import React, { useState } from 'react';
import { Typography } from 'antd';
import CreditsList from './CreditsList';
import CreditDetail from './CreditDetail';

const { Title } = Typography;

interface Credit {
  id: string;
  [key: string]: any;
}

const CreditsTab: React.FC = () => {
  const [selectedCredit, setSelectedCredit] = useState<Credit | null>(null);

  const handleSelectCredit = (credit: Credit) => {
    setSelectedCredit(credit);
  };

  const handleBack = () => {
    setSelectedCredit(null);
  };

  const handleUpdate = () => {
    // Stay on detail view but refresh data
    // The detail component handles its own refresh
  };

  if (selectedCredit) {
    return (
      <CreditDetail
        creditId={selectedCredit.id}
        onBack={handleBack}
        onUpdate={handleUpdate}
      />
    );
  }

  return (
    <div>
      <Title level={4} style={{ marginBottom: 16 }}>
        Credit Management
      </Title>
      <CreditsList onSelect={handleSelectCredit} />
    </div>
  );
};

export default CreditsTab;
